import List from '@mui/material/List';
import type { FC, PropsWithChildren } from 'react';

const CheckboxList: FC<PropsWithChildren> = ({ children }) => {
  return <List sx={{ width: '100%' }}>{children}</List>;
};

export default CheckboxList;
